import React, { useRef, useState, useMemo } from "react";
import { useFrame } from "@react-three/fiber";
import { useGLTF } from "@react-three/drei";
import * as THREE from "three";

export default React.memo(function Mushroom({
  position,
  scale = 1,
  rotation,
  type = 0,
}) {
  const variant = (type % 5) + 1;
  const { scene } = useGLTF(`/mushroom_${variant}.glb`);
  const ref = useRef();
  const [hovered, setHovered] = useState(false);
  const [pressed, setPressed] = useState(false);

  // Use refs for animation values to avoid re-renders every frame
  const yOffsetRef = useRef(0);
  const currentScaleRef = useRef(scale);

  // Clonar la escena para que cada hongo sea independiente
  const clonedScene = useMemo(() => scene.clone(true), [scene]);

  useFrame(() => {
    if (!ref.current) return;
    ref.current.rotation.y += 0.001;

    // Smooth Y offset animation
    const targetY = hovered ? 0.4 : 0;
    yOffsetRef.current += (targetY - yOffsetRef.current) * 0.08;

    // Smooth scale animation
    const targetScale = pressed ? scale * 0.88 : scale;
    currentScaleRef.current += (targetScale - currentScaleRef.current) * 0.18;

    ref.current.position.y = position[1] + yOffsetRef.current;
    const s = currentScaleRef.current;
    ref.current.scale.set(s, s, s);
  });
  return (
    <group
      ref={ref}
      position={position}
      scale={[scale, scale, scale]}
      rotation={rotation}
      onPointerOver={() => setHovered(true)}
      onPointerOut={() => setHovered(false)}
      onPointerDown={() => setPressed(true)}
      onPointerUp={() => setPressed(false)}
      onPointerLeave={() => setPressed(false)}
    >
      <primitive object={clonedScene} />
    </group>
  );
});
